
import React, { useState, useEffect } from 'react';
import tapIcon from '../../../services/TapIcon';
import Ax from "../../../components/hoc/Ax";
import { connect, useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import AppBaseComponent from "../../../components/AppBaseComponent";
import HttpAPICall from "../../../services/HttpAPICall";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';
import TapSelect from '../../../components/ui/TapSelect';

const AddSection = ({ history, location }) => {
    const sectionUrl        =   BACKOFFICE_BASE_URL + '/section';

    const initAddSectionForm = {
        name: '',
        sub_section_ids: [],
        notes: ''
    };

    const [saveFormSubmitting, setSaveFormSubmitting] = useState(false);
    const [addSectionForm, setAddSectionForm] = useState({ ...initAddSectionForm });
    const [formLoading, setFormLoading] = useState(false);
    const [editResource, setEditResource] = useState(false);
    const [subSectionList, setSubSectionList] = useState([]);

    const [editName, setEditName]   =   useState('');
    const [nameExit, setNameExit]   =   useState(false);
    const [searchExitName, setSearchExitName] = useState(false);

    const access_token = useSelector(state => state.auth.access_token);
    useEffect(() => {
        getSearchFormData()
    }, []);

    const closeEvent = () => {
        setAddSectionForm({ ...initAddSectionForm });
        setEditName('');
        setNameExit(false);
        history.push({ pathname: `/sections_list` });
    };

    const handleBlur    =   ()  => {
        const {name} = addSectionForm
        if(name && name !== editName) {
            setEditName(name);
            setSearchExitName(true);
            HttpAPICall.withAthorization('GET', sectionUrl + '/with_name?name=' + name, access_token, {}, {}, (resp) => {
                if(resp.data > 0) {
                    setNameExit(true)
                }else {
                    setNameExit(false)
                }
            }).then(() => setSearchExitName(false));
        }
    }

    const getSearchFormData = () => {
        setFormLoading(true);

        HttpAPICall.withAthorization('GET', sectionUrl + '/form_data', access_token, {}, {}, (resp) => {
            let respData = resp.data.sub_sections;
            setSubSectionList(respData && respData.length > 0 ? respData.map(v => ({ value: v.id, label: v.subcomponent })) : []);
        }).then(() => {
            setFormLoading(false)

            if (location.state && location.state.editSectionData) {
            let detail = location.state.editSectionData;
            setEditName(detail.name);

            setAddSectionForm(pre => ({
                ...pre,
                id: detail.id,
                name: detail.name,
                notes: detail.notes || "",
                sub_section_ids: detail.sub_sections.map(sb => sb.id),
            }));
            setEditResource(true);
        }

        })
    }           

    const submitAddSectionForm = (e) => {
        e.preventDefault();
        const formData = {
            ...addSectionForm,
        };
        if (editResource) {
            setSaveFormSubmitting(true);
            HttpAPICall.withAthorization('PUT', sectionUrl + '/edit', access_token, {}, { ...formData }, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                closeEvent()
            }).then(() => {
                setSaveFormSubmitting(false)
                setEditResource(false)
            });
        } else {
            setSaveFormSubmitting(true);
            HttpAPICall.withAthorization('POST', sectionUrl + '/add', access_token, {}, { ...formData }, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                closeEvent()
            }).then(() => setSaveFormSubmitting(false));
        }

    };

    const formInputHandler = (e, formName) => {
        const { name, value } = e.target;
        if (formName === "addSectionForm") {
            setAddSectionForm(prevState => ({ ...prevState, [name]: value }));
        }
    };
    const tapSelectChange = (selectedOption, form, formKey) => {
        if (form && formKey) {
            const newStateData = Array.isArray(selectedOption)
                ? { ...addSectionForm, [formKey]: selectedOption.length > 0 ? selectedOption.map(o => o.value) : [] }
                : { ...addSectionForm, [formKey]: selectedOption ? selectedOption.value : '' };

            setAddSectionForm(newStateData);
        }
    };

    const saveSectionFormJsx = () => {
        return (
            <form className="bg-white p-3" onSubmit={submitAddSectionForm} id="saveResourceForm">
                {formLoading ? <Loader />
                    : <Ax>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="name" className="form-label require">Name</label>
                            </div>
                            <div className="col-sm-6">
                                <input
                                    name="name"
                                    type="text"
                                    value={addSectionForm.name}
                                    className="form-control"
                                    autoComplete="off"
                                    required={true}
                                    onChange={(e) => formInputHandler(e, "addSectionForm")}
                                    onBlur={handleBlur}
                                    placeholder="Please enter Name"
                                />
                                {
                                nameExit && 
                                <span className="text-danger">* Section not available,try another</span>
                                }
                            </div>
                        </div>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="path" className="form-label">Sub Section</label>
                            </div>
                            <div className="col-sm-6">
                                <TapSelect
                                    changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'addSectionForm', 'sub_section_ids')}
                                    options={subSectionList}
                                    isSearchable={true}
                                    isClearable={true}
                                    isMulti={true}
                                    required={true}
                                    value={subSectionList.filter(s => addSectionForm.sub_section_ids.includes(s.value))}
                                    placeholder={"Please Select Sub section"}
                                />
                            </div>
                        </div>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="notes" className="form-label require">Notes</label>
                            </div>
                            <div className="col-sm-6 add_calender_section">
                                <textarea
                                    name="notes"
                                    value={addSectionForm.notes}
                                    onChange={(e) => formInputHandler(e, 'addSectionForm')}
                                    className="form-control"
                                    style={{ height: "100px" }}
                                    required={true}
                                />
                            </div>
                        </div>
                    </Ax>}
                <div className="col-12 text-end fixed_footer">
                    <button type="button" disabled={saveFormSubmitting} onClick={closeEvent} className="btn btn-secondary mx-3">Cancel</button>
                    <button type="submit" disabled={saveFormSubmitting || searchExitName} className="btn btn-primary mx-2">
                        Save {saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                </div>
            </form>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Section Add</title></Helmet>
            <div className="page_title row m0">
                <div className="col-12">
                    <h3>{editResource ? "Edit" : "Add"} Section</h3>
                    <div className="text-end mt15">
                        <button onClick={closeEvent} disabled={saveFormSubmitting} type="button" className="btn btn-secondary">
                            <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Fuel Station" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        {saveSectionFormJsx()}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};


export default AddSection;
